import React from 'react';
import BrandLoader from 'shared/components/ui/BrandLoader';

/**
 * Kept so every call site stays as it is: the numeric `size` these were
 * given (32 in a cell, 144 as a hero) maps onto the one loader's sizes.
 */
const TrodoLoader = ({ size = 120, className = '', label = 'Loading' }) => {
  const s = size < 48 ? 'sm' : size <= 100 ? 'md' : size <= 120 ? 'lg' : 'xl';
  return <BrandLoader size={s} label={label} className={className} />;
};

export default TrodoLoader;
